<template>
  <div class="layout">
  <Layout>
    <AdminTop />
    <Layout>
    <Sider hide-trigger :style="{background: '#fff'}">
    <AdminMenu />
  </Sider>
    <Layout :style="{padding: '0 24px 24px'}">
      <AdminBread />
      <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
  <Table border :columns="columns" :data="keywords">
    <template #keyword="{ row }">
        <strong>{{ row.keyword }}</strong>
    </template>
    <template #action="{ row }">
        <Button type="error" size="small" @click="keywordDelete(row.id)" style="margin-right: 5px">删除</Button>
        <Button type="info" size="small" @click="gotoEdit(row)" style="margin-right: 5px">修改</Button>
        
        <Button v-if="row.isPrefix==1" type="primary" size="small" @click="keywordPrefix(row.id, 0)" style="margin-right: 5px">取消预设</Button>
        <Button v-else type="primary" size="small" @click="keywordPrefix(row.id, 1)">预设问题</Button>
    </template>
  </Table>

  <div id="pager"><Page :total="num" @on-change="pageChange" show-total /></div>

</Content>
    </Layout>
    </Layout>
  </Layout>
  </div>
</template>
<script>
import AdminTop from '../../components/AdminTop.vue'
import AdminMenu from '../../components/AdminMenu.vue'
import AdminBread from '../../components/AdminBread.vue'
import global from '../../utils/global'
import axios from 'axios'

export default {
  components: {
    AdminTop,
    AdminMenu,
    AdminBread
  },
  data () {
    return {
      user: null,
      
      keywords:[],
      page: 1,
      num: 0,
      status: 0,
      columns: [
        {
          title: '关键词',
          slot: 'keyword',
          width: 200
        },
        {
          title: '回复内容',
          key: 'replyContent',
          minWidth: 120
        },
        {
          title: '创建时间',
          key: 'updateTime',
          width: 200
        },
        {
          title: '操作',
          slot: 'action',
          width: 230,
          align: 'center'
        }
      ],
    }
  },

  mounted() {
    this.initUser()
    this.keywordsList()
  },
  methods: {
    //初始化用户信息
    initUser() {
        let userStr = localStorage.getItem("user")
        if(userStr!=null) {
          this.user = JSON.parse(userStr)
        } else {
          this.$router.push({path: '/'})
        }
      },

    keywordsList() {
      let vm = this
      axios({
        method: 'post',
        url: global.restUrl + '/api/manage/robot/v1.0/keyword/list',
        data: {
          limit:10,
          page: vm.page
        },
        headers: {
          token: vm.user.token
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          let data = response.data.data
          if(data.list!=null) {
          vm.keywords = data.list
          } else {
            vm.keywords = []
          }
          vm.num = data.num
        }
      });
    },
    //翻页
    pageChange(page) {
      this.page = page
      this.keywordsList()
    },

    //修改问题预设状态
    keywordPrefix(id, isPrefix) {
      let vm = this
      axios({
        method: 'post',
        url: global.restUrl + '/api/manage/robot/v1.0/keyword/prefix',
        data: {
          id:id,
          isPrefix:isPrefix
        },
        headers: {
          token: vm.user.token
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          vm.keywordsList()
        }
      });
    },
    
    //修改
    gotoEdit(item) {
      this.$router.push({path: '/admin/keyword/edit', query: {id: item.id}});
    },
    
    //删除
    keywordDelete(id) {
      let vm = this
        axios({
          method: 'post',
          url: global.restUrl + '/api/manage/robot/v1.0/delete/by-id',
          data: {
            id: id
          },
          headers: {
            token: vm.user.token
          }
        }).then(function (response) {
          let success = response.data.success
          if(success) {
            vm.keywordsList()
          }
        });
    }
  }
}
</script>
